module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-comparison__discount-select"
  }, [_c('div', {
    staticClass: "u-margin-top-20 u-margin-bottom-10 u-bold"
  }, [_vm._v("\n        Discount Rates (please select a maximum of two)\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin flex-grid--wrap u-r-flex-direction-row"
  }, _vm._l((_vm.discountRates), function(discount, index) {
    return _c('div', {
      staticClass: "a-checkbox a-checkbox--label-above"
    }, [_c('input', {
      attrs: {
        "autocomplete": "off",
        "type": "checkbox",
        "disabled": _vm.disableRate(discount)
      },
      domProps: {
        "value": discount,
        "checked": _vm.checkedRate(discount)
      },
      on: {
        "click": _vm.toggle
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "text"
      }
    }, [_vm._v(_vm._s(discount + '%'))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76e93ca6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/form/DiscountRates.vue
// module id = 1748
// module chunks = 0